export const APPLICATION_MANAGEMENT_GATE = 'application_management'
export const PMU_PORTAL_GATE = 'enable_pmu_portal'
export const PMU_APPLICATION_ACTIONS_GATE = 'pmu_application_actions'
export const ENABLE_GEO_SCRUTINY_ENGINE = 'enable_geo_scrutiny_engine'
export const RELIEVE_AND_DISTRIBUTE_GATE = 'enable_relieve_and_distribute'
export const REPLACE_OFFICER_GATE = 'enable_replace_officer'
export const RETURN_FROM_LEAVE_GATE = 'enable_return_from_leave'
export const NEW_USER_NEW_OFFICER_GATE = 'enable_new_user_new_officer'
